var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlerta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.19,
    height: 81.938,
    viewBox: "0 0 91.19 81.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15619",
    "data-name": "Grupo 15619",
    transform: "translate(-637.395 -269.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15056",
    "data-name": "Grupo 15056",
    transform: "translate(842.908 255.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_17",
    "data-name": "Uni\\xF3n 17",
    d: "M4.1,57.793H88.3S69.16,80.3,41.635,80.909q-.524.012-1.039.012C13.858,80.921,4.1,57.793,4.1,57.793Zm.141,0S-2.359,49.259.907,32.776c2.053-10.368,10.679-15.5,22.242-15.014,3.975.169,10.443-4.855,19.734-11.026C62.76-6.464,91.512-.858,84.63,28.832,81.3,43.2,95.1,43.431,88.244,57.793Z",
    transform: "translate(-205 15)",
    fill: "#fecad6",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.327
  })), /*#__PURE__*/React.createElement("g", {
    id: "peligro",
    transform: "translate(653 249.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15529",
    "data-name": "Grupo 15529",
    transform: "translate(0 35.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15528",
    "data-name": "Grupo 15528",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76059",
    "data-name": "Trazado 76059",
    d: "M58.309,78.607,34.079,38.423a5.307,5.307,0,0,0-9.089,0L.76,78.607a5.307,5.307,0,0,0,4.545,8.047h48.46a5.307,5.307,0,0,0,4.545-8.047Zm-3.272,3.459a1.463,1.463,0,0,1-1.272.743H5.305a1.461,1.461,0,0,1-1.251-2.215l24.23-40.183a1.461,1.461,0,0,1,2.5,0l24.23,40.183A1.463,1.463,0,0,1,55.037,82.065Z",
    transform: "translate(0 -35.857)",
    fill: "red"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15531",
    "data-name": "Grupo 15531",
    transform: "translate(26.948 51.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15530",
    "data-name": "Grupo 15530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76060",
    "data-name": "Trazado 76060",
    d: "M236.183,173.005c-1.463,0-2.6.785-2.6,2.177,0,4.246.5,10.347.5,14.593,0,1.106.964,1.57,2.105,1.57.856,0,2.069-.464,2.069-1.57,0-4.246.5-10.347.5-14.593A2.293,2.293,0,0,0,236.183,173.005Z",
    transform: "translate(-233.578 -173.005)",
    fill: "red"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15533",
    "data-name": "Grupo 15533",
    transform: "translate(26.841 72.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15532",
    "data-name": "Grupo 15532",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76061",
    "data-name": "Trazado 76061",
    d: "M235.4,353.306a2.747,2.747,0,0,0,0,5.495,2.748,2.748,0,0,0,0-5.495Z",
    transform: "translate(-232.651 -353.306)",
    fill: "red"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerta);
export default __webpack_public_path__ + "static/media/alerta.e83184e5cf0bbd768651d800e3e372fc.svg";
export { ForwardRef as ReactComponent };